import { cn } from '@client/lib/utils';

interface AnswerOptionProps {
  label: string;
  description: string;
  isSelected: boolean;
  onClick: () => void;
}

export function AnswerOption({ label, description, isSelected, onClick }: AnswerOptionProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'flex w-full items-center justify-between rounded-xl border-2 p-4 text-left transition-all',
        isSelected
          ? 'border-primary bg-primary/5'
          : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50',
      )}
    >
      <div className="flex flex-col gap-0.5">
        <span className="text-base font-medium text-gray-900">{label}</span>
        <span className="text-sm text-gray-600">{description}</span>
      </div>
      <div
        className={cn(
          'ml-4 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 transition-colors',
          isSelected ? 'border-primary bg-primary' : 'border-gray-300',
        )}
      >
        {isSelected && <div className="h-2 w-2 rounded-full bg-white" />}
      </div>
    </button>
  );
}

